var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fl-check" },
    [
      _c("div", { staticClass: "container" }, [
        _c("p", [
          _c(
            "b",
            {
              staticStyle: {
                cursor: "pointer",
                "font-size": "16px",
                "border-bottom": "2px dashed #333",
                "font-weight": "500",
              },
              on: {
                click: function ($event) {
                  _vm.showDescr = !_vm.showDescr
                },
              },
            },
            [_vm._v("Описание")]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "uk-icon-question-circle",
            staticStyle: {
              "vertical-align": "top",
              "font-size": "0.8rem",
              "padding-left": "2px",
            },
          }),
        ]),
        _vm._v(" "),
        _vm.showDescr
          ? _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-weight": "400",
                  margin: "20px 0",
                  "max-width": "960px",
                  padding: "20px",
                  background: "#eee",
                  border: "1px solid lightgray",
                  "border-radius": "5px",
                },
              },
              [
                _c("b", [
                  _vm._v(
                    "Среднее время проверки составляет от 0.5 до 3 минут."
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n            Сформированный отчёт будет загружен в виде файла в вашем браузере.\n            "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n            Позволяет оперативно обнаружить негативные факторы в отношении ФЛ (вхождение в «черные списки», банкротство, большие суммы налоговых задолженностей или исполнительных производств и прочие), а также другую важную информацию на стадии до начала сотрудничества, а также дать основания для прекращения текущего сотрудничества, если в процессе будут выявлены новые появившиеся негативные факторы.\n            "
                ),
                _c("br"),
                _vm._v(
                  "\n            Позволяет выявить возможность сотрудничества с ФЛ в качестве ИП или самозанятого и использовать выгоды соответствующих режимов налогообложения.\n            "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Типовые примеры использования:")]),
                _vm._v(" "),
                _vm._m(0),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rasporka", staticStyle: { "padding-top": "5px" } },
          [
            _c("ul", { staticClass: "fl-check__list" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("passports") }, [
                _vm._v("Проверка паспорта"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("check_inn") }, [
                _vm._v("Проверка ИНН"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("fed_rozysk") }, [
                _vm._v("Реестр федерального розыска МВД РФ"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("terrorists") }, [
                _vm._v("Реестр террористов/экстремистов"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("fsin") }, [
                _vm._v("Реестр розыска ФСИН"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("fssp_fl_rozysk_yk") }, [
                _vm._v("Реестр розыска ФССП (совершенные преступления)"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("fssp_fl_rozysk_ip") }, [
                _vm._v("Реестр розыска ФССП (по исполнительным производствам)"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("fssp_fl_ip") }, [
                _vm._v("Банк данных исполнительных производств ФССП"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("bankrupt") }, [
                _vm._v("Реестр банкротств физических лиц"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("dismissed_person") }, [
                _vm._v("Реестр лиц, уволенных в связи с утратой доверия"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("nedoimki") }, [
                _vm._v("Налоговая задолженность ФЛ"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("pledge") }, [
                _vm._v("Реестр залогов движимого имущества"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("disq_person") }, [
                _vm._v(" Реестр дисквалифицированных лиц ФНС РОССИИ"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("restrict_on_part_ul") }, [
                _vm._v("Реестр ограничений участия в ЮЛ ФНС РОССИИ"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("check_ip") }, [
                _vm._v("Наличие статуса ИП"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("self_employed") }, [
                _vm._v("Наличие статуса самозанятого"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("mass_person") }, [
                _vm._v("Реестр массовых руководителей"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("mass_person") }, [
                _vm._v("Реестр массовых учредителей"),
              ]),
              _vm._v(" "),
              _c("li", { class: _vm.getClass("affil") }, [
                _vm._v("Аффилированные структуры"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form" }, [
              _c("div", { staticClass: "form__container rasporka" }, [
                _c(
                  "div",
                  { staticClass: "form__box", staticStyle: { float: "left" } },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.surname,
                          expression: "surname",
                        },
                      ],
                      staticClass: "surname",
                      attrs: { type: "text", placeholder: "Фамилия" },
                      domProps: { value: _vm.surname },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.surname = $event.target.value
                          },
                          function ($event) {
                            return _vm.onInput(
                              $event,
                              "surname",
                              /[^а-яa-z-]/gi
                            )
                          },
                        ],
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__box", staticStyle: { float: "left" } },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      staticClass: "name",
                      attrs: { type: "text", placeholder: "Имя" },
                      domProps: { value: _vm.name },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          },
                          function ($event) {
                            return _vm.onInput($event, "name", /[^а-яa-z-]/gi)
                          },
                        ],
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__box", staticStyle: { float: "left" } },
                  [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.patronymic,
                          expression: "patronymic",
                        },
                      ],
                      staticClass: "patronymic",
                      attrs: { type: "text", placeholder: "Отчество" },
                      domProps: { value: _vm.patronymic },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.patronymic = $event.target.value
                          },
                          function ($event) {
                            return _vm.onInput(
                              $event,
                              "patronymic",
                              /[^а-яa-z-]/gi
                            )
                          },
                        ],
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__box", staticStyle: { float: "right" } },
                  [
                    _c("div", { staticClass: "form__header" }, [
                      _vm._v("Дата рождения"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.birthday,
                          expression: "birthday",
                        },
                      ],
                      staticClass: "birthday",
                      attrs: {
                        type: "text",
                        placeholder: "31.12.2020",
                        maxlength: "10",
                      },
                      domProps: { value: _vm.birthday },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.birthday = $event.target.value
                          },
                          function ($event) {
                            return _vm.onInput($event, "birthday")
                          },
                        ],
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form__container rasporka",
                  staticStyle: { "margin-top": "15px" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form__box",
                      staticStyle: { float: "left" },
                    },
                    [
                      _c("div", { staticClass: "form__header" }, [
                        _vm._v("ИНН ФЛ"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inn,
                            expression: "inn",
                          },
                        ],
                        staticClass: "inn",
                        attrs: {
                          placeholder: "ИНН ФЛ",
                          type: "text",
                          maxlength: 12,
                        },
                        domProps: { value: _vm.inn },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inn = $event.target.value
                            },
                            function ($event) {
                              return _vm.onInput($event, "inn", /[^0-9]/g)
                            },
                          ],
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form__box",
                      staticStyle: { float: "right" },
                    },
                    [
                      _c("div", { staticClass: "form__header" }, [
                        _vm._v("Серия и номер паспорта"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.serial,
                            expression: "serial",
                          },
                        ],
                        staticClass: "serial",
                        attrs: {
                          placeholder: "Серия",
                          type: "text",
                          maxlength: 4,
                        },
                        domProps: { value: _vm.serial },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.serial = $event.target.value
                            },
                            function ($event) {
                              return _vm.onInput($event, "serial", /[^0-9]/g)
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.number,
                            expression: "number",
                          },
                        ],
                        staticClass: "number",
                        attrs: {
                          placeholder: "Номер",
                          type: "text",
                          maxlength: 6,
                        },
                        domProps: { value: _vm.number },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.number = $event.target.value
                            },
                            function ($event) {
                              return _vm.onInput($event, "number", /[^0-9]/g)
                            },
                          ],
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form__container rasporka",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("label", { attrs: { for: "approve" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hasApproval,
                          expression: "hasApproval",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "approve",
                        id: "approve",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.hasApproval)
                          ? _vm._i(_vm.hasApproval, null) > -1
                          : _vm.hasApproval,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.hasApproval,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.hasApproval = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.hasApproval = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.hasApproval = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Настоящим подтверждаю наличие письменного или иным образом зафиксированного согласия физического лица на обработку его персональных данных."
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form__container rasporka",
                  staticStyle: { "margin-top": "20px", "text-align": "right" },
                },
                [
                  _c(
                    "button",
                    { staticClass: "btn", on: { click: _vm.clearForm } },
                    [_vm._v("Очистить")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn blue",
                      class: { inactive: _vm.getInapproval() },
                      attrs: { disabled: _vm.getInapproval() },
                      on: { click: _vm.sendForm },
                    },
                    [_vm._v("Поиск")]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.limits
                ? _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "text-align": "right",
                      },
                    },
                    [
                      _vm._v(
                        "Использовано запросов: " +
                          _vm._s(_vm.limits.used_total)
                      ),
                      _vm.limits.total
                        ? _c("span", [
                            _vm._v(" из " + _vm._s(_vm.limits.total)),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._m(5),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "span",
                { staticStyle: { color: "#444", "font-size": "12px" } },
                [
                  _vm._v(
                    "Данные подготавливаются. Приблизительное время ожидания не более 5 минут."
                  ),
                ]
              ),
              _vm._v(" "),
              _c("shestirenka"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("fl-history", { ref: "history" }),
      _vm._v(" "),
      _vm.upload
        ? _c("flCheckPdf", {
            attrs: {
              dateCheck: _vm.dateCheck,
              list: _vm.list,
              upload: _vm.upload,
              name: _vm.name,
              surname: _vm.surname,
              patronymic: _vm.patronymic,
              birthday: _vm.birthday,
              serial: _vm.serial,
              number: _vm.number,
              inn: _vm.inn ? _vm.inn : _vm.checkedInn,
              inputInn: _vm.inn,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticStyle: { "list-style-type": "disc", width: "100%" } },
      [
        _c("li", [_vm._v("проверка потенциальных контрагентов-ФЛ")]),
        _vm._v(" "),
        _c("li", [_vm._v("проверка кандидатов на работу")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "периодическая проверка отдельных контрагентов-ФЛ (например, раз в месяц/квартал/год)"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "периодическая проверка сотрудников (например, раз в месяц/квартал/год)"
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      {
        staticClass: "fl-check__list__subheader",
        staticStyle: { "font-size": "24px" },
      },
      [_c("b", [_vm._v("Проверяемые реестры:")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("Фамилия"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("Имя"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("Отчество"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { float: "right" } }, [
      _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")]),
      _vm._v(" - поля обязательные к заполнению"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }